import { activeLink, linkLabel } from 'components/sidebar/sidebarLinks';
import UseContext from 'hooks/useContext';
import MediaQuery from 'react-responsive';
import { useLocation } from 'react-router-dom';
import NavbarDesktop from './NavbarComponents/NavbarDesktop/NavbarDesktop';

// Pages outside the sidebar, by the first segment of their path. A page of
// the sidebar takes the label of its link.
const OTHER_PAGE_TITLES = {
  'admin-console': 'Console d’administration',
  'admin-profil': 'Mon profil',
  profil: 'Profil',
  searchMission: 'Recherche de mission',
  documents: 'Mes documents',
  mission: 'Mes missions',
};

const Navbar = ({ title: pageTitle }) => {
  const { pathname } = useLocation();
  const { language } = UseContext();
  const link = activeLink(pathname);
  let title = OTHER_PAGE_TITLES[pathname.split('/')[1]];
  if (link) title = link.pageTitle ? link.pageTitle() : linkLabel(language, link);
  if (pageTitle) title = pageTitle;

  return (
    <header className="sticky top-0 z-20 w-full border-b border-gray-100 bg-white">
      <div className="px-4 lg:px-8">
        <div className="-mb-px flex h-[60px] items-center justify-between tab:h-[70px]">
          {/* The prototype's page title, a little lighter: Poppins 18 px, medium, tightened. */}
          <h1 className="font-Poppins text-lg font-medium leading-6 tracking-[-0.3px] text-gray-900">{title}</h1>
          <MediaQuery minWidth={769}>
            <div className="flex items-center gap-4 px-2">
              <NavbarDesktop />
            </div>
          </MediaQuery>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
